import styled, { css } from 'styled-components';

export const RequestInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${({ theme }) => theme.palette.bodySecondary};
  width: 100%;
`;

export const RequestInfoHead = styled.div`
  padding: 2.4rem 3.6rem 0 2rem;
`;

export const RequestInfoTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 2.2rem;
  line-height: 2.8rem;
  color: ${({ theme }) => theme.palette.text};
`;

export const RequestInfoDate = styled.span`
  font-size: 1.1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.palette.secondaryText};
`;

export const RequestInfoBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ $margin }) => ($margin ? `${$margin}rem` : '0rem')};
`;

export const RequestInfoActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  ${({ $mt }) =>
    $mt &&
    css`
      margin-top: ${$mt}rem;
    `}

  ${({ $mb }) =>
    $mb &&
    css`
      margin-bottom: ${$mb}rem;
    `}
`;

export const RequestInfoAction = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.4rem;
  height: 3.4rem;
  border-radius: 4px;
  background-color: transparent;
  border: none;
  transition: 0.5s;
  cursor: pointer;
  .icon {
    stroke: ${({ theme }) => theme.palette.secondaryText};
    width: 2rem;
    height: 2rem;
  }
  &:hover {
    &.duplicate {
      background-color: ${({ theme }) => theme.palette.siderSecondary};
      .icon {
        stroke: ${({ theme }) => theme.palette.text};
      }
    }
    &.cancel {
      background-color: ${({ theme }) => theme.palette.statusCanceledSecondary};
      .icon {
        stroke: ${({ theme }) => theme.palette.buttonText};
      }
    }
    &.edit {
      background-color: ${({ theme }) => theme.palette.sider};
      .icon {
        stroke: ${({ theme }) => theme.palette.buttonText};
      }
    }
    &.delete {
      background-color: ${({ theme }) => theme.palette.actionDelete};
      .icon {
        stroke: ${({ theme }) => theme.palette.buttonText};
      }
    }
    &.send {
      background-color: ${({ theme }) => theme.palette.actionSend};
      .icon {
        stroke: ${({ theme }) => theme.palette.buttonText};
      }
    }
    &.archive {
      background-color: ${({ theme }) => theme.palette.actionArchive};
      .icon {
        stroke: ${({ theme }) => theme.palette.buttonText};
      }
    }
  }
`;

export const RequestInfoText = styled.p`
  margin: 0;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${({ theme }) => theme.palette.text};

  ${({ $success }) =>
    $success &&
    css`
      span {
        color: ${({ theme }) => theme.palette.providerChosen};
      }
    `}

  ${({ $error }) =>
    $error &&
    css`
      span {
        color: ${({ theme }) => theme.palette.providerError};
      }
    `}
`;

export const RequestInfoContent = styled.div`
  overflow: hidden;
  .ant-tabs {
    height: 100%;
    &-content-holder {
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0rem;
        height: 0rem;
      }
    }
    &-tabpane {
      padding: 3rem 2.5rem 3rem;
    }
  }
`;

export const RequestInfoComment = styled.div`
  margin: 1rem 0rem 0rem 0rem;
  font-size: 1.6rem;
  line-height: 2.4rem;
  background-color: ${({ theme }) => theme.palette.card};
  padding: 1rem;
  max-width: 40rem;
`;

export const RequestInfoItem = styled.div`
  ${({ $mb }) =>
    $mb &&
    css`
      margin-bottom: ${$mb}rem;
    `}

  ${({ $mt }) =>
    $mt &&
    css`
      margin-top: ${$mt}rem;
    `}
`;

export const RequestInfoWrap = styled.div``;
